export default "/institutions/sicoob.svg";